import React from 'react';
import CommonEmptyState from '../../../components/common/EmptyState/EmptyState';

interface EmptyStateProps {
  message: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ message }) => {
  return <CommonEmptyState message={message} />;
};

export default EmptyState;
